<template>
  <div v-if="isMounted">
    <vs-switch v-if="investorPlan.contracts_signed" color="success" v-model="autoInvestPayments"
      @click.stop="confirmSwitchInvestmentPlanOption('autoinvest_applicant_payments', !autoInvestPayments)" />
    <vs-button v-else size="small" type="border" @click="automaticInvestmentContractPopUpActive = true">Firmar</vs-button>

    <vs-popup :active.sync="automaticInvestmentContractPopUpActive" title="Inversión Automática" class="extended-popup header-primary">
      <div class="vx-col w-full m-0">
        <div class="vx-row no-gutter items-center justify-center">
          <div slot="no-body" class="">
            <div class="vx-col sm:w-full">
              <div class="login-tabs-container">
                <div class="vx-row m-0">
                  <div class="vx-col w-full p-0" style="min-height: 200px">
                    <!-- MAIN-DIV -->
                    <div class="px-6 pt-5 pb-5">
                      <!-- CONTENT -->
                      <div class="main-form mt-base">
                        <div class="vx-row">
                          <div :class="colClassFull">
                            <vx-card class="border-primary">
                              <div style="height:400px; overflow-y:scroll; overflow-x: hidden;">
                                <!-- VERSION 2.0 DE CONSENTIMIENTO DE INVERSION AUTOMATICA -->
                                <automatic-investment-consent-v2 :fill-user-data="true" />
                              </div>
                              <p class="mt-base">
                                Podrás habilitar y deshabilitar la Inversión Automática (que se encuentra desactivada
                                por defecto) en el momento en que lo requieras en el apartado “Inversión Automática”.
                              </p>
                              <p class="mt-5">
                                Consiento que la Inversión Automática utilice los recursos de:
                              </p>
                              <div class="checkbox-display">
                                <vs-checkbox name="terms" v-model.lazy="acceptAutoInvestApplicantPayments">
                                </vs-checkbox>
                                Los pagos de Solicitantes y Operaciones no perfeccionadas.
                              </div>
                              <div class="checkbox-display">
                                <vs-checkbox name="terms" v-model.lazy="acceptAutoInvestOtherResources">
                                </vs-checkbox>
                                Otros recursos.
                              </div>
                              <p class="mt-5 text-center">
                                Al dar clic en Autorizar aceptas los <a class="inline-link-primary" target="_blank"
                                  rel="noopener" @click="popUpAutomaticInvestmentTermsContract = true"> términos y
                                  condiciones</a> de la Inversión Automática
                              </p>
                            </vx-card>
                          </div>
                        </div>
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="flex flex-wrap justify-end mt-5">
                              <vs-button
                                :disabled="!acceptAutoInvestApplicantPayments || !acceptAutoInvestOtherResources"
                                @click.stop="signAndActivateAutoInvestApplicantPayments">Autorizar y
                                activar</vs-button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- END CONTENT DIV -->
                    </div>
                    <!-- END MAIN-DIV -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Popup para ver terminos y condiciones de inversion automatica -->
          <vs-popup :active.sync="popUpAutomaticInvestmentTermsContract" title="Términos y condiciones"
            class="extended-popup header-primary">
            <latest-automatic-investment-terms-conditions-contract />
          </vs-popup>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import LatestAutomaticInvestmentTermsConditionsContract from "@views/investor/contracts/LatestAutomaticInvestmentTermsConditionsContract.vue";
import AutomaticInvestmentConsentV2 from "@views/investor/contracts/AutomaticInvestmentConsentV2.vue";
export default {
  name: "AutomaticInvestmentButton",
  props: {
    investorPlanDefault: { type: Object, default: null},
  },
  components: {
    LatestAutomaticInvestmentTermsConditionsContract,
    AutomaticInvestmentConsentV2
  },
  mixins: [],
  data() {
    return {
      colClass: "vx-col md:w-1/2 sm:w-full w-full mb-5",
      colClassFull: "vx-col w-full",
      automaticInvestmentContractPopUpActive: false,
      popUpAutomaticInvestmentTermsContract: false,
      isMounted: false,
      autoInvestPayments: false,
      investorPlan: {
        id: null,
        card_id: null,
        card_amount: null,
        reinvestment_percentage: null,
        qualifications: null,
        monthly_day: null,
        available_money: null,
        retry: null,
        min_autoinvest_project_amount_mxn: null,
        max_autoinvest_project_amount_mxn: null,
        autoinvest_applicant_payments: null,
        autoinvest_deposits: null,
        suspendedDirectBillingBankAccount: null,
        contracts_signed: true
      },
      switchPlanOption: null,
      switchPlanValue: null,
      acceptAutoInvestApplicantPayments: false,
      acceptAutoInvestOtherResources: false,
      currentLocation: null,
      locationOptions: {
        enableHighAccuracy: true,
        timeout: Infinity,
        maximumAge: 0
      },
    }
  },
  async mounted() {
    this.showLoading(true);
    this.isMounted = false;
    await this.loadPrefs();
    this.isMounted = true;
    // si no se han firmado los contratos de inv automatica se pide la geolocalizacion
    if (!this.investorPlan.contracts_signed) {
      if ('geolocation' in navigator) {
        await navigator.geolocation.getCurrentPosition(this.onSuccessLocation, this.onErrorLocation, this.locationOptions);
      }
    }
    this.showLoading(false);
  },
  methods: {
    async loadPrefs() {
      if (!this.investorPlanDefault) {
        await this.getPlansInfo();
      } else {
        this.investorPlan = this.investorPlanDefault;
      }
      await this.setDefaults();
    },
    async getPlansInfo() {
      try {
        const res = await axios.get(`api/v2/investor/${this.InvestorId}/getInvestorPlansInfo`);
        this.investorPlan = res.data.plan;
      }
      catch (e) {
      }
    },
    confirmSwitchInvestmentPlanOption(option, value) {
      let message = "";
      let title = "";
      this.switchPlanOption = option;
      this.switchPlanValue = value;
      // si se va a activar no se muestra mensaje de confirmacion
      if (value) {
        this.switchInvestmentPlanOption();
        return;
      }
      let firstText = value == 1 ? "reactivar" : "pausar";
      let secondText = value == 1 ? "reactivado" : "pausado";
      let thirdText = firstText == "reactivar" ? "pausar" : "reactivar";
      switch (option) {
        case "autoinvest_applicant_payments":
          title = "¿Estás seguro que deseas " + firstText + " la inversión automática?";
          message = "El proceso de inversión automática será " + secondText + ", lo puedes " + thirdText + " en cualquier momento.";
          break;
        default:
          break;
      }
      this.successDialogWithCallbacks(
        this.switchInvestmentPlanOption,
        () => {
          if (option == "autoinvest_applicant_payments") {
            this.autoInvestPayments = !this.autoInvestPayments;
          } else if (option == "autoinvest_deposits") {
            this.directBillingisActive = true;
          }
        },
        title,
        message,
        "Confirmar",
        "Cancelar"
      );
    },
    async signAndActivateAutoInvestApplicantPayments() {
      this.automaticInvestmentContractPopUpActive = false;
      this.popUpAutomaticInvestmentTermsContract = false;
      this.switchPlanOption = "sign_contract_and_autoinvest_applicant_payments";
      this.switchPlanValue = true;
      await this.switchInvestmentPlanOption();
    },
    async switchInvestmentPlanOption() {
      this.showLoading(true)
      try {
        let geolocation = null;
        if (this.currentLocation) {
          geolocation = "Lat: " + this.currentLocation.latitude + ", Long: " + this.currentLocation.longitude;
        }

        let payload = {
          option: this.switchPlanOption,
          value: this.switchPlanValue,
          geolocation: geolocation,
          contractType: null
        };
        this.injectAccountMetadataToPayload(payload);
        await axios.post(`api/v2/investor/${this.InvestorId}/switchInvestmentPlanOption`, payload);
        this.showLoading(true);
        this.isMounted = false;
        this.automaticInvestmentContractPopUpActive = false;
        this.popUpAutomaticInvestmentTermsContract = false;
        await this.loadPrefs();
        this.isMounted = true;
        this.showLoading(false);
        this.successNotif(
          "Operación exitosa",
          "Se han actualizado exitosamente tus preferencias"
        );
        this.$emit('automatic-investment-changed', this.switchPlanValue);
      }
      catch (e) {
        const mssg = this.catchError(e);
        this.errorNotif('Error en la operación', mssg);
      }
      this.showLoading(false);
    },
    catchError(e) {
      if (e?.response?.data?.error) {
        return e.response.data.error
      }
      else {
        return "No ha sido posible actualizar la información";
      }
    },
    async setDefaults() {
      this.autoInvestPayments = this.investorPlan.autoinvest_applicant_payments === 1;
    },
    async onSuccessLocation(pos) {
      this.currentLocation = pos.coords;
    },
    onErrorLocation(err) {
      // console.log(err);
    },
  }
}
</script>

<style scoped>
.vx-card.border-primary {
  border-style: solid;
  border-width: 1px;
}

.checkbox-display {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}
</style>
